import React, { useEffect, useMemo, useState } from 'react';
import { Star } from 'lucide-react';
import LandingSection from './LandingSection';
import LandingCard from './LandingCard';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '../ui/carousel';

const TESTIMONIALS = [
  {
    name: 'Anita Sharma',
    school: 'Green Valley Public School',
    rating: 5,
    quote: 'Attendance and fee tracking became effortless. The portals keep everyone aligned.',
  },
  {
    name: 'Rahul Mehta',
    school: 'Sunrise Academy',
    rating: 5,
    quote: 'Clean UI, fast workflows, and reports we can actually use. Setup was smooth.',
  },
  {
    name: 'Priya Nair',
    school: 'St. Mary’s School',
    rating: 4,
    quote: 'Great role-based access—teachers see exactly what they need. Parents love the portal.',
  },
  {
    name: 'Vikram Singh',
    school: 'Oxford Senior Secondary',
    rating: 5,
    quote: 'Fees, receipts, and exports are rock solid. We upgraded after the first week.',
  },
];

function Stars({ n }) {
  return (
    <div className="flex items-center gap-1" aria-label={`${n} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className={`h-4 w-4 ${i < n ? 'text-amber-300' : 'text-white/15'}`}
          fill={i < n ? 'currentColor' : 'none'}
        />
      ))}
    </div>
  );
}

export default function LandingTestimonials() {
  const [api, setApi] = useState(null);
  const items = useMemo(() => TESTIMONIALS, []);

  useEffect(() => {
    if (!api) return undefined;
    const prefersReducedMotion = typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) return undefined;

    const id = window.setInterval(() => {
      api.scrollNext();
    }, 4500);

    return () => window.clearInterval(id);
  }, [api]);

  return (
    <LandingSection
      id="testimonials"
      title="Testimonials"
      subtitle="Trusted by teams that want simple, reliable school operations."
      innerClassName=""
      withTopDivider
    >
      <Carousel setApi={setApi} opts={{ align: 'start', loop: true }}>
        <CarouselContent className="-ml-3">
          {items.map((t) => (
            <CarouselItem key={t.name} className="basis-[92%] pl-3 sm:basis-[60%] lg:basis-[33%]">
              <LandingCard className="h-full p-5" hover>
                <Stars n={t.rating} />
                <p className="mt-3 text-sm leading-relaxed text-white/70">
                  “{t.quote}”
                </p>
                <div className="mt-4 flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full border border-white/10 bg-white/[0.04]" />
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-white">{t.name}</p>
                    <p className="text-xs text-white/55">{t.school}</p>
                  </div>
                </div>
              </LandingCard>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </LandingSection>
  );
}

